import { FileInput } from '@bbl-digital/snorre'
import { IEmailAttachment } from 'Modules/Communication/Email/shared/models/Email'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SkeletonFileInput from 'shared/components/skeletons/SkeletonFileInput'
import { maxEmailFileSize } from 'shared/constants/email'
import { SEND_EMAIL_UPDATE_ATTACHMENTS_REQUESTED } from 'shared/store/sendMessage/email/actionTypes'
import { getSendEmail } from 'shared/store/sendMessage/email/selectors'
import { mapAttachments } from 'shared/utils/mapAttachments'
import { AttachmentsWrapper } from './styles'

const SendEmailAttachments: FC = () => {
  const { message, savingAttachments, messageId } = useSelector(getSendEmail)
  const dispatch = useDispatch()

  const handleAttachmentsChange = (files: File[]) => {
    dispatch({
      type: SEND_EMAIL_UPDATE_ATTACHMENTS_REQUESTED,
      payload: {
        files,
        id: messageId,
        originalFiles: message?.attachments || [],
      },
    })
  }

  return (
    <AttachmentsWrapper>
      {savingAttachments ? (
        <SkeletonFileInput length={message?.attachments?.length} />
      ) : (
        <FileInput
          initialFiles={mapAttachments<IEmailAttachment>(message?.attachments)}
          onChange={(files) => handleAttachmentsChange(files as File[])}
          fileMaxsixe={maxEmailFileSize}
          multiple
        />
      )}
    </AttachmentsWrapper>
  )
}

export default SendEmailAttachments
